import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _slicedToArray } from '../../unsorted/slicedToArray.js';
import { _ as _typeof } from '../../unsorted/typeof.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo, Children, isValidElement } from 'react';
import { f as flattenChildren } from '../../unsorted/index3.js';
import { m as merge } from '../../unsorted/index.js';
import { useConvertSxToEmotionStyles } from '../../hooks/useConvertSxToEmotionStyles.js';
import { useTheme } from '../../hooks/useTheme.js';
import { cloneElementWithCssProp } from '../../utils/componentHelpers.js';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { s as smartPickTokenValue } from '../../utils/processTokenUtils.js';

var _excluded = ["testId", "children", "domRef", "className", "viewBox", "sx", "rc"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CUSTOM_CSS_GRADIENT_ERROR = "<SvgIcon /> does not support fill styles that are css-gradients. Custom gradients must be converted into SVG gradient syntax.";
var RESPONSIVE_GRADIENT_ERROR = "Due to the complexity involved, <SvgIcon /> does not yet support responsive gradients. Please only use a single gradient token. If this functionality is required, please indicate your interest in this functionality using the following jira ticket: https://immutable.atlassian.net/browse/DS-114.";
var GRADIENT_REGEX = /base\.gradient|linear-gradient|radial-gradient/g;
var DEFAULT_SX_PROPS = {
  fill: "base.color.text.body.primary",
  w: "base.icon.size.100"
};
function SvgIcon(_ref) {
  var testId = _ref.testId,
    children = _ref.children,
    domRef = _ref.domRef,
    className = _ref.className,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? "0 0 24 24" : _ref$viewBox,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("svg", {}) : _ref$rc,
    svgDomAttributes = _objectWithoutProperties(_ref, _excluded);
  var themeProps = useTheme();
  var gradientTokens = {
    spectrum: "",
    blendMode: "",
    svgDefs: "",
    svgDefIds: ""
  };
  if (typeof sx.fill === "string") {
    if (sx.fill.includes("base.gradient")) {
      gradientTokens = smartPickTokenValue(themeProps, sx.fill);
    } else if (sx.fill.match(/linear-gradient|radial-gradient/g)) {
      throw new Error(CUSTOM_CSS_GRADIENT_ERROR);
    }
  } else if (_typeof(sx.fill) === "object") {
    // @TODO: we should eventually allow the ability to supply responsive gradients
    // but for now, we'll throw an error if we detect that the user is trying to do this
    var isArrayAndIncludesGradient = false;
    var isObjectAndIncludesGradient = false;
    if (Array.isArray(sx.fill)) {
      isArrayAndIncludesGradient = Boolean(sx.fill.find(function (item) {
        return typeof item === "string" && item.match(GRADIENT_REGEX);
      }));
    } else {
      isObjectAndIncludesGradient = Boolean(Object.entries(sx.fill).find(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          value = _ref3[1];
        return typeof value === "string" && value.match(GRADIENT_REGEX);
      }));
    }
    if (isArrayAndIncludesGradient || isObjectAndIncludesGradient) {
      throw new Error(RESPONSIVE_GRADIENT_ERROR);
    }
  }
  var _gradientTokens = gradientTokens,
    svgDefs = _gradientTokens.svgDefs,
    svgDefIds = _gradientTokens.svgDefIds;
  var svgDefIdsAsArray = svgDefIds === null || svgDefIds === void 0 ? void 0 : svgDefIds.split(",").map(function (id) {
    return id.trim();
  });
  var flattenedChildren = useMemo(function () {
    return flattenChildren(children);
  }, [children]);
  var clonedChildren = (svgDefIds === null || svgDefIds === void 0 ? void 0 : svgDefIds.length) > 1 ? Children.map(flattenedChildren, function (child) {
    return svgDefIdsAsArray.map(function (id) {
      var clonedChild = /*#__PURE__*/isValidElement(child) ? cloneElementWithCssProp(child, {
        key: id,
        css: {
          fill: "url(#".concat(id, ")")
        }
      }) : null;
      return clonedChild;
    });
  }) : [children];
  var sxWithDefaults = merge(DEFAULT_SX_PROPS, sx);
  var customStyles = useConvertSxToEmotionStyles(sxWithDefaults);
  var modifiedChildren = jsxs(Fragment, {
    children: [svgDefs && jsx("defs", {
      dangerouslySetInnerHTML: {
        __html: svgDefs
      }
    }), clonedChildren]
  });
  return cloneElementWithCssProp(rc, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, svgDomAttributes), testId ? {
    "data-testid": testId
  } : {}), domRef ? {
    ref: domRef
  } : {}), {}, {
    viewBox: viewBox,
    className: "SvgIcon ".concat(className !== null && className !== void 0 ? className : ""),
    xmlns: "http://www.w3.org/2000/svg",
    css: customStyles,
    children: modifiedChildren
  }));
}
SvgIcon.displayName = "SvgIcon";

export { SvgIcon as S };
//# sourceMappingURL=SvgIcon.js.map
